<template>
  <div class="container">
    <top :title="title"></top>

    <div class="infos">
      <!-- 订单基本信息卡片 -->
      <div class="info-card basic-info">
        <!-- 卡片头部 -->
        <div class="card-header">
          <div class="order-no">
            订单号：<span>{{ goodObj.orderNumber }}</span>
          </div>
          <div class="style-no">
            款号：<span>{{ goodObj.styleCode }}</span>
          </div>
        </div>

        <!-- 卡片主体 -->
        <div class="card-body">
          <!-- 顶部信息区块 -->
          <div class="top-section">
            <!-- 图片预览 -->
            <div class="img-preview-section">
              <div>
                <!-- <img
                  v-for="(img, index) in imgs"
                  :key="index"
                  :src="img.trim() || 'default-image.jpg'"
                  class="good-img img-preview"
                  alt="产品图片"
                /> -->
                <image-preview v-for="(img,index) in imgs" :key="index" :src="img" :width="120" :height="120" />
              </div>
            </div>

            <!-- 基本信息右侧 -->
            <div class="basic-info-section">
              <div class="info-row">
                <div class="info-label">客户：</div>
                <div class="info-value">{{ goodObj.customerName || "-" }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">销售：</div>
                <div class="info-value">{{ goodObj.saleName || "-" }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">面料：</div>
                <div class="info-value">
                  {{ goodObj.fabricName }}
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">纸样：</div>
                <div class="info-value">
                  {{ goodObj.patternName }}
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">订单类型：</div>
                <div class="info-value">
                  <!-- <span class="type-tag offline"> -->
                  {{ goodObj.typeStr }}
                  <!-- </span> -->
                </div>
              </div>
            </div>
          </div>

          <!-- 订单数量区块 -->
          <div class="order-quantity-section">
            <div class="section-header">
              <div class="section-title">尺码</div>
              <div class="total-quantity">
                总计：<span class="total">{{ goodObj.number || 0 }}</span
                >件
              </div>
            </div>

            <div class="quantity-grid">
              <div
                class="size-item"
                v-for="(item, index) in goodObj.detailList"
                v-if="item.number > 0"
                :key="index"
              >
                <div class="size-label">{{ item.sizeValue || "尺寸" }}</div>
                <div class="size-value">{{ item.number || 0 }}</div>
              </div>
            </div>
          </div>

          <!-- 备注区块 -->
          <div class="remark-section">
            <div class="section-title">备注</div>
            <div class="remark-content">{{ goodObj.remark }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import { getOrderInfo } from "@/http/index";

export default {
  components: { top },
  data() {
    return {
      id: "",
      title: "订单详情",
      imgs: [],
      goodObj: {},
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getInfo();
  },
  methods: {
    getInfo() {
      getOrderInfo(this.id).then((res) => {
        this.goodObj = res.data;
        if (this.goodObj && this.goodObj.img) {
          this.imgs = this.goodObj.img.split(",");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #f5f7fa;
}

.infos {
  padding: 16px;
  padding-bottom: 20px;
}

/* 卡片通用样式 */
.info-card {
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  position: relative;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  .order-no,
  .style-no {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.9);

    span {
      font-weight: 700;
      color: #ffffff;
      font-family: "Courier New", monospace;
    }
  }
}

.card-body {
  padding: 20px;
}

/* 顶部信息区块 */
.top-section {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    flex-direction: column;
  }
}

.img-preview-section {
  flex-shrink: 0;

  .section-title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 12px;
  }

  .img-preview {
    width: 140px;
    height: 140px;
    border-radius: 12px;
    // overflow: hidden;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
    border: 1px solid #eef0f3;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);

    .good-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.05);
      }
    }
  }
}

.basic-info-section {
  flex: 1;
  min-width: 200px;

  .info-row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f2f5;

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }

    .info-label {
      flex-shrink: 0;
      width: 80px;
      font-size: 14px;
      color: #606266;
    }

    .info-value {
      flex: 1;
      font-size: 15px;
      color: #303133;
      font-weight: 500;
    }

    .type-tag {
      display: inline-block;
      padding: 4px 12px;
      border-radius: 6px;
      font-size: 13px;
      font-weight: 500;

      &.offline {
        background: #f0f7ff;
        color: #409eff;
        border: 1px solid #d9ecff;
      }

      &.online {
        background: #f0f9ff;
        color: #67c23a;
        border: 1px solid #e1f3d8;
      }
    }
  }
}

/* 中间信息区块 */
.middle-section {
  margin-bottom: 24px;
  padding: 20px;
  background: #fafbfc;
  border-radius: 12px;
  border: 1px solid #f0f2f5;

  .info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;

    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }
  }

  .info-item {
    .info-label {
      font-size: 14px;
      color: #909399;
      margin-bottom: 8px;
      font-weight: 500;
    }

    .info-content {
      font-size: 16px;
      color: #303133;
      font-weight: 600;
      padding: 8px 12px;
      background: white;
      border-radius: 8px;
      border: 1px solid #e4e7ed;
    }
  }
}

/* 订单数量区块 */
.order-quantity-section {
  margin-bottom: 24px;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }

    .total-quantity {
      font-size: 14px;
      color: #606266;

      .total {
        font-size: 20px;
        font-weight: 700;
        color: #e24a41;
        margin: 0 4px;
      }
    }
  }

  .quantity-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 12px;
    margin-bottom: 16px;

    .size-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 16px 8px;
      background: linear-gradient(135deg, #f8f9fa 0%, #f1f3f5 100%);
      border-radius: 10px;
      border: 1px solid #eef0f3;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        border-color: #409eff;
      }

      .size-label {
        font-size: 14px;
        color: #606266;
        margin-bottom: 6px;
        font-weight: 500;
      }

      .size-value {
        font-size: 20px;
        font-weight: 700;
        color: #e24a41;
      }
    }
  }

  .size-summary {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
    padding: 12px 16px;
    background: #f8f9fa;
    border-radius: 8px;
    border-left: 4px solid #409eff;

    .summary-item {
      font-size: 14px;
      color: #606266;
      padding: 4px 8px;
      background: white;
      border-radius: 4px;
      border: 1px solid #e4e7ed;
    }

    .summary-more {
      font-size: 13px;
      color: #909399;
      font-style: italic;
    }
  }
}

/* 备注区块 */
.remark-section {
  padding: 20px;
  // background: linear-gradient(135deg, #fff9f9 0%, #fff5f5 100%);
  border-radius: 12px;
  border: 1px solid #ffeaea;

  .section-title {
    font-size: 15px;
    font-weight: 600;
    color: #e24a41;
    margin-bottom: 12px;
    display: flex;
    align-items: center;

    &::before {
      content: "";
      display: inline-block;
      width: 4px;
      height: 16px;
      background: #e24a41;
      margin-right: 8px;
      border-radius: 2px;
    }
  }

  .remark-content {
    font-size: 14px;
    color: #606266;
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-word;
    padding: 12px;
    background: white;
    border-radius: 8px;
    border: 1px solid #ffeaea;
  }
}

/* 订单状态 */
.order-status {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;

  .status-tag {
    display: inline-block;
    padding: 6px 16px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    &.pending {
      background: #fff3e0;
      color: #f57c00;
      border: 1px solid #ffe0b2;
    }

    &.processing {
      background: #e3f2fd;
      color: #1976d2;
      border: 1px solid #bbdefb;
    }

    &.completed {
      background: #e8f5e9;
      color: #388e3c;
      border: 1px solid #c8e6c9;
    }

    &.cancelled {
      background: #ffebee;
      color: #d32f2f;
      border: 1px solid #ffcdd2;
    }
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .infos {
    padding: 12px;
  }

  .card-header {
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    .order-no,
    .style-no {
      font-size: 14px;
    }
  }

  .card-body {
    padding: 16px;
  }

  .img-preview {
    width: 120px !important;
    height: 120px !important;
    margin-right: 10px;
  }

  .quantity-grid {
    grid-template-columns: repeat(auto-fill, minmax(70px, 1fr)) !important;
    gap: 10px !important;
  }
}

@media (max-width: 480px) {
  .order-status {
    position: static;
    margin-top: 16px;
    text-align: center;
  }
}
</style>
